<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="snDetailsEdit.pkid ? '编辑' : '新建'"
    width="900px"
    append-to-body
    @close="$reset('form')"
  >
    <el-form ref="form" :model="snDetailsEdit" class="form" label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="元码编号">
            <el-select v-model="snDetailsEdit.metaDataNo" placeholder="请选择元码编号">
              <el-option v-for="item in metaDataNoList" :key="item.key" :label="item.value" :value="item.key" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="标签个数">
            <el-input v-model="snDetailsEdit.lableLength" placeholder="请输入标签个数" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="元码标签">
            <el-input v-model="snDetailsEdit.metaDataLable" placeholder="请输入元码标签" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="元码名称">
            <el-input v-model="snDetailsEdit.metaDataName" placeholder="请输入元码名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="数据源">
            <el-input v-model="snDetailsEdit.dataSource" placeholder="请输入数据源" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="后缀">
            <el-input v-model="snDetailsEdit.suffixChar" placeholder="请输入后缀" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否验证">
            <el-radio-group v-model="snDetailsEdit.isVerify">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "BarCodeRulesDetailsEdit",
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      metaDataNoList: [],
      snDetailsEdit: {
        metaDataNo: "",
        metaDataLable: "",
        metaDataName: "",
        lableLength: "",
        dataSource: "",
        suffixChar: "",
        isVerify: false,
      },
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.getMetaDataNoList();
      });
    },

    getMetaDataNoList() {
      this.$http.get("basic", "snRule/selectMetaDataNos").then((resp) => {
        if (resp.success) {
          this.metaDataNoList = resp.data;
        }
      });
    },

    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit("save-success", this.snDetailsEdit);
          this.dialogVisible = false;
        }
      });
    },
  },
};
</script>
